import { action } from 'satcheljs';
export default action('SELECT_PREVIOUS_NODE_INTERNAL', function (actionSource) {
    return { actionSource: actionSource };
});
//# sourceMappingURL=selectPreviousNodeInternal.js.map